import { OrderExtra } from '../../domains/order/order-extra';

export class BasketExtra extends OrderExtra {
  price: number;
  priceTotal: number;
}
